<template>
  <section class="bottom-cta">
    <div class="default-container">
      <h3>{{ $t('titoloBottomCta') }}</h3>
      <p v-html="$t('testoBottomCta')"></p>
      <router-link
        :to="{ name: `${lang}-richiesta-contatti`, params: { lang } }"
        class="link-triangle-effect">
        {{ $t('testoLinkBottomCta') }}
      </router-link>
    </div>
  </section>
</template>

<script>

export default {
  props: {
    lang: {
      type: String,
      required: true
    }
  }
}

</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

.bottom-cta{
  background: #1D1D1B;

  padding: 90px 0;

  @media #{$medium_mq} {
    padding: 120px 0 140px;
  }
  @media #{$large_mq} {
    padding: 160px 0 180px;
  }
  @media #{$xlarge_mq} {
    padding: 190px 0 220px;
  }
  @media #{$xxlarge_mq} {
    padding: 220px 0 240px;
  }

  h3{
    @include size-16-pixel(#4A4A4A); color: #EFEFF1;
    font-weight: 500; text-transform: uppercase;
    font-family: 'Roboto', sans-serif;
  }
  p {
    @include section-title-cta(#545454);
    font-family: 'Sectra'; font-weight: 400;
    margin: 3rem 0 4rem;
    br{
      display: none;
      @media #{$xlarge_mq} {
        display: block;
      }
    }
  }
  .link-triangle-effect{
    @include link-triangle-effect(#EFEFF1);
  }
}
</style>
